/*
 * MDB shim for MDBTabPane
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/InventoryProduct/inventoryProductView.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueView.jsx
 * - src/Seating/Tasks/Tasks.jsx
 */

import { useContext } from "react";
import MUIBox from "@mui/material/Box";
import { MDBTabContext } from "./MDBTabContent";

export default function MDBTabPane({ children, tabId, activeItem, ...rest }) {
  const contextActiveItem = useContext(MDBTabContext);
  const resolvedActiveItem = activeItem ?? contextActiveItem;

  if (
    resolvedActiveItem != null &&
    tabId != null &&
    String(resolvedActiveItem) !== String(tabId)
  ) {
    return null;
  }

  return <MUIBox {...rest}>{children}</MUIBox>;
}
